/**
 * @fileoverview GET handler for the "/funnel_reports/:report_id/:app_group_id/details" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { funnelReportsReportIdAppGroupIdDetails } from "./constants";
import type { FunnelReportDetails } from "./types";

export const getFunnelReportDetails = reactQueryFetcherAdapter(
  funnelReportsReportIdAppGroupIdDetails,
  (signal: AbortSignal, reportId: string, appGroupId: string): Promise<FunnelReportDetails> => {
    return fetch(`/funnel_reports/${reportId}/${appGroupId}/details`, "GET", {}, { signal });
  }
);
